// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9-Wrd","largestCol":"styles_largestCol__2gmv8","smallestCol":"styles_smallestCol__17brr"};